// お客様No.入力ルール
const clientCodeRules = [
  v => !!v || 'お客様No.を入力してください',
  v => (!v.match(/[^0-9]/) && v.length === 9) || '半角数字9桁で入力してください',
]

// 塾名入力ルール
const customerNameRules = [
  v => !!v || '塾名を入力してください',
  v => v.length <= 50 || '50文字以内で入力してください',
]

// 教室名入力ルール
const classroomNameRules = [
  v => !!v || '教室名を入力してください',
  v => v.length <= 50 || '50文字以内で入力してください',
]

// 郵便番号入力ルール
const postCodeRules = [
  v => !v || !v.includes('-') || '-（ハイフン）無しで入力してください。',
  v => !v || (!v.match(/[^0-9]/) && v.length == 7) || '半角数字7桁で入力してください',
]

// 住所入力ルール
const addressRules = [
  v => !!v || '住所を入力してください',
  v => !v || v.length <= 100 || '100文字以内で入力してください'
]

// 電話番号入力ルール
const telRules = [
  v => !!v || '電話番号を入力してください',
  v => !v || (!v.match(/[^0-9]/) && v.length <= 11) || '半角数字11桁以内で入力してください',
]

// メールアドレス入力ルール
const mailRules = [
  v => !!v || 'メールアドレスを入力してください',
  v => !v || /^[a-zA-Z0-9-_.+?/]+@([a-zA-Z0-9][a-zA-Z0-9-_.]*\.)+[a-zA-Z]{2,}$/.test(v) || 'メールアドレスが有効ではありません',
  v => !v || v.length <= 100 || '100文字以内で入力してください',
  v => !v || !v.includes('..') || '「.(ドット)」は連続して使用しないでください',
  v => !v || v.slice(0,1)!=='.' || '「.(ドット)」を先頭で使用しないでください',
  v => !v || v.split('@')[0].slice(-1)!=='.' || '「.(ドット)」を「@(アットマーク)」の直前で使用しないでください',
  v => !v || v.split('@')[0].length<=64 || '「@(アットマーク)」の前は64文字以内にしてください',
]

// 担当者入力ルール
const representativeRules = [
  v => !v || v.length <= 20 || '20文字以内で入力してください'
]

// 教室担当者入力ルール
const classroomChargePersonRules = [
  v => !!v || '担当者名を入力してください',
  v => !v || v.length <= 20 || '20文字以内で入力してください'
]

// ロゴ画像入力ルール
const logoRules = [
  v => {
    if (!v) return true
    if (v.size >= 1000000) return 'ロゴ画像は1MB以内のファイルにしてください'
    return true
  }
]

// ログインID
const loginIdRules = [
  v => !!v || 'ログインIDを入力してください',
  v => v.length <= 30 || '30文字以内で入力してください',
  v => {
    const illegalChar = v.match(/[^a-zA-Z0-9_\\-\\.@]/)
    return !illegalChar || `「${illegalChar[0]}」は使用できません`
  }
]

// 利用開始日
const startDateRules = [
  v => !!v || '利用開始日を入力してください'
]

export default Object.freeze({
  clientCode: clientCodeRules,
  customerName: customerNameRules,
  classroomName: classroomNameRules,
  tel: telRules,
  postCode: postCodeRules,
  address: addressRules,
  mail: mailRules,
  representative: representativeRules,
  classroomChargePerson: classroomChargePersonRules,
  logo: logoRules,
  loginId: loginIdRules,
  startDate: startDateRules,
})
